<template>
  <div
    class="header-wrapper"
    :class="{
      absolute: !banner,
    }">
    <div
      v-if="showBanner"
      ref="banner"
      class="top-banner"
      :class="{
        'blue-variation': site.banner.use_blue_variation,
      }">
      <div class="banner-content">
        <div class="inner-container">
          <img
            v-if="site.banner.use_blue_variation"
            :src="site.banner.icon.url"
            :alt="site.banner.icon.alt" />

          <div
            class="banner-text"
            v-html="site.banner.text"></div>

          <a
            v-if="site.banner.button.url && !site.banner.use_blue_variation"
            class="banner-button"
            :href="site.banner.button.url"
            :target="site.banner.button.target"
            :title="site.banner.button.title"
            v-html="site.banner.button.title">
          </a>
        </div>
        <button
          v-if="site.banner.show_x_icon"
          class="exit"
          @click="setBannerShown()">
          <svg
            class="animation-background"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M5.72 5.72a.75.75 0 011.06 0L12 10.94l5.22-5.22a.75.75 0 111.06 1.06L13.06 12l5.22 5.22a.75.75 0 11-1.06 1.06L12 13.06l-5.22 5.22a.75.75 0 01-1.06-1.06L10.94 12 5.72 6.78a.75.75 0 010-1.06z"
              fill="#ffffff" />
          </svg>
        </button>
      </div>
    </div>

    <header
      id="header-nav"
      ref="header"
      class="no-cursor header-nav white"
      :class="{
        'nav-open': navOpen,
        'desktop-mega-open': activeDesktopMegaItem,
        mobile: device === 'tablet' || device === 'mobile',
        'has-banner': showBanner,
        'no-banner': !banner,
      }">
      <nav
        ref="navWrapper"
        @mouseleave="device === 'desktop' ? closeDesktopMegaMenu() : null">
        <ul
          v-if="
            device === 'desktop' && !hideNav && topLevelMenu(topMenu).length
          "
          class="desktop-top-menu">
          <li
            v-for="item in topLevelMenu(topMenu)"
            :key="`top-menu-${item.id}`"
            class="desktop-top-menu-item">
            <a
              v-if="isExternal(item.url)"
              class="desktop-top-menu-link"
              :href="item.url"
              :target="item.target || '_self'"
              :title="item.title || item.content"
              v-html="item.content"></a>
            <router-link
              v-else
              class="desktop-top-menu-link"
              :to="convertToRelative(item.url)"
              :target="item.target"
              :title="item.title || item.content"
              v-html="item.content"></router-link>
          </li>
        </ul>

        <div class="branding">
          <div class="logo-container">
            <a href="/">
              <div v-show="device === 'desktop'">
                <div v-if="true">
                  <div
                    ref="lottieContainer"
                    class="lottie-container" />
                </div>
                <div v-else>
                  <img
                    v-if="site.site_logo?.url && !sticky"
                    :src="site.site_logo?.url || ''" />
                  <img
                    v-else
                    :src="site.site_logo_sticky?.url || ''" />
                </div>
              </div>
              <div v-show="device !== 'desktop'">
                <div
                  v-if="true"
                  class="logo-container-mobile">
                  <div
                    id="lottie-container"
                    ref="lottieContainerMobile"
                    class="lottie-container"
                    :class="{ 'logo-not-visible': navOpen }" />
                  <img
                    class="logo-white"
                    :class="{ 'logo-visible': navOpen }"
                    src="@/assets/img/revmed-white.svg" />
                </div>
                <div v-else>
                  <img :src="site.site_logo_sticky?.url || ''" />
                </div>
              </div>
            </a>
          </div>
          <div
            v-if="!hideNav"
            class="mobile-nav"
            @click="toggle">
            <span class="line line-one" />
            <span class="line line-two" />
            <span class="line line-three" />
          </div>
        </div>
        <ul
          v-if="device === 'desktop' && !hideNav"
          ref="nav"
          class="nav-container hidden lg:flex">
          <template v-if="preIntroShown">
            <transition-group
              v-for="(item, index) in topLevelMenu(menu)"
              :key="item.id"
              tag="li"
              appear
              @before-enter="beforeEnter"
              @enter="enter"
              @mouseenter="openDesktopMegaMenu(item)"
              @focusin="openDesktopMegaMenu(item)"
              @click="item.class[0] === '' ? close(false) : null">
              <template v-if="item.parent === '0'">
                <template v-if="item.class[0] != 'search_link'">
                  <NavMenuItem
                    :key="item.id"
                    :data-ind="index"
                    :menu="menu"
                    :item="item"
                    :desktop-mega-active="activeDesktopMegaItem?.id === item.id"
                    :mobile="device === 'mobile' ? 'mobile-menu-show' : ''"
                    @open-desktop-mega="openDesktopMegaMenu(item)"
                    @clicked="close" />
                </template>
                <template v-else-if="item.class[0] === 'orange'">
                  <NavMenuItem
                    :key="item.id"
                    :data-ind="index"
                    :menu="menu"
                    :item="item"
                    :desktop-mega-active="activeDesktopMegaItem?.id === item.id"
                    :mobile="device === 'mobile' ? 'mobile-menu-show' : ''"
                    @open-desktop-mega="openDesktopMegaMenu(item)"
                    @clicked="close" />
                </template>
                <template v-else>
                  <img
                    id="searchIcon"
                    :key="item.id"
                    :src="searchIcon"
                    alt="Search icon"
                    @click="showSearch" />

                  <Search
                    v-if="displaySearch == true"
                    @display-search="showSearch"></Search>
                </template>
              </template>
            </transition-group>
          </template>
        </ul>
        <div
          v-else-if="!hideNav"
          class="nav-wrapper">
          <!-- <focus-trap v-model:active="navOpen"> -->
          <ul
            ref="nav"
            data-lenis-prevent
            class="nav-container nav-mobile">
            <template v-if="introShown">
              <transition-group
                v-for="(item, index) in topLevelMenu(mobileNavigationMenu)"
                :key="item.id"
                tag="li"
                appear
                @before-enter="beforeEnter"
                @enter="enter"
                @click="
                  item.class[0] === '' &&
                  !childrenOf(item, mobileNavigationMenu).length
                    ? close(false)
                    : null
                ">
                <template v-if="item.parent === '0'">
                  <template v-if="item.class[0] != 'search_link'">
                    <NavMenuItem
                      :key="item.id"
                      :data-ind="index"
                      :menu="mobileNavigationMenu"
                      :item="item"
                      :mobile="device === 'mobile' ? 'mobile-menu-show' : ''"
                      @clicked="close" />
                  </template>
                  <template v-else-if="item.class[0] === 'orange'">
                    <NavMenuItem
                      :key="item.id"
                      :data-ind="index"
                      :menu="mobileNavigationMenu"
                      :item="item"
                      :mobile="device === 'mobile' ? 'mobile-menu-show' : ''"
                      @clicked="close" />
                  </template>
                  <template v-else>
                    <img
                      id="searchIcon"
                      :key="item.id"
                      :src="searchIcon"
                      alt="Search icon"
                      @click="showSearch" />

                    <Search
                      v-if="displaySearch == true"
                      @display-search="showSearch"></Search>
                  </template>
                </template>
              </transition-group>
            </template>
          </ul>
          <!-- </focus-trap> -->
        </div>
        <div
          v-if="device === 'desktop' && !hideNav"
          id="desktop-mega-menu"
          class="desktop-mega-menu"
          :class="{
            'is-open': activeDesktopMegaItem && desktopSecondaryItems.length,
          }"
          :aria-hidden="
            !(activeDesktopMegaItem && desktopSecondaryItems.length)
          ">
          <div class="desktop-mega-surface">
            <Transition name="desktop-mega-content">
              <div
                v-if="activeDesktopMegaItem && desktopSecondaryItems.length"
                :key="`desktop-mega-content-${activeDesktopMegaItem.id}`"
                class="desktop-mega-content-layer">
                <div
                  v-if="desktopTertiaryGroups.length"
                  class="desktop-mega-tertiary">
                  <p
                    v-for="secondary in desktopSecondaryItems"
                    :key="`secondary-${secondary.id}`"
                    class="desktop-mega-secondary-title"
                    v-html="secondary.content"></p>

                  <div class="desktop-mega-tertiary-content">
                    <ul
                      v-for="group in desktopTertiaryGroups"
                      :key="`tertiary-group-${group.secondary.id}`"
                      class="desktop-mega-tertiary-list">
                      <li
                        v-for="(tertiary, tertiaryIndex) in group.items"
                        :key="tertiary.id"
                        class="desktop-mega-tertiary-item"
                        :style="{ '--mega-item-index': tertiaryIndex }">
                        <a
                          v-if="isExternal(tertiary.url)"
                          class="desktop-mega-tertiary-link"
                          :href="tertiary.url"
                          :target="tertiary.target || '_self'"
                          :title="tertiary.title || tertiary.content"
                          @click="closeDesktopMegaMenu">
                          <span
                            class="desktop-mega-tertiary-title"
                            v-html="tertiary.content"></span>
                          <span
                            v-if="tertiary.description"
                            class="desktop-mega-tertiary-description"
                            v-html="tertiary.description"></span>

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none">
                            <path
                              d="M15.7642 15.4981L15.3976 15.1315L15.388 9.01375C15.3826 5.56271 15.6686 4.54354 15.6419 4.15134C15.6415 3.88989 15.5629 3.81134 15.4321 3.7327C15.3012 3.65407 15.1445 3.70611 14.9878 3.86273C14.6746 4.17597 13.892 5.2728 11.6993 7.46549L1.59728 17.5675L1.0744 17.5667L0.000816064 16.4931L0 15.9702L10.1281 5.8421C12.3208 3.64942 13.4176 2.8668 13.7309 2.55356C13.8875 2.39694 13.9395 2.24016 13.8609 2.10932C13.7823 1.97847 13.7037 1.89992 13.4423 1.89951C13.0763 1.89894 12.0309 2.15875 8.57986 2.15337L2.46212 2.14382L2.09553 1.77723L2.09333 0.365448L2.45878 0L17.0472 0.0227578L17.5186 0.494087L17.5675 15.1087L17.2021 15.4742L15.7903 15.472L15.7642 15.4981Z"
                              fill="#1E6B5C"
                              fill-opacity="0.5" />
                          </svg>
                        </a>
                        <router-link
                          v-else
                          class="desktop-mega-tertiary-link"
                          :to="convertToRelative(tertiary.url)"
                          :target="tertiary.target"
                          :title="tertiary.title || tertiary.content"
                          @click="closeDesktopMegaMenu">
                          <span
                            class="desktop-mega-tertiary-title"
                            v-html="tertiary.content"></span>
                          <span
                            v-if="tertiary.description"
                            class="desktop-mega-tertiary-description"
                            v-html="tertiary.description"></span>

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none">
                            <path
                              d="M15.7642 15.4981L15.3976 15.1315L15.388 9.01375C15.3826 5.56271 15.6686 4.54354 15.6419 4.15134C15.6415 3.88989 15.5629 3.81134 15.4321 3.7327C15.3012 3.65407 15.1445 3.70611 14.9878 3.86273C14.6746 4.17597 13.892 5.2728 11.6993 7.46549L1.59728 17.5675L1.0744 17.5667L0.000816064 16.4931L0 15.9702L10.1281 5.8421C12.3208 3.64942 13.4176 2.8668 13.7309 2.55356C13.8875 2.39694 13.9395 2.24016 13.8609 2.10932C13.7823 1.97847 13.7037 1.89992 13.4423 1.89951C13.0763 1.89894 12.0309 2.15875 8.57986 2.15337L2.46212 2.14382L2.09553 1.77723L2.09333 0.365448L2.45878 0L17.0472 0.0227578L17.5186 0.494087L17.5675 15.1087L17.2021 15.4742L15.7903 15.472L15.7642 15.4981Z"
                              fill="#1E6B5C"
                              fill-opacity="0.5" />
                          </svg>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script setup>
// import { FocusTrap } from 'focus-trap-vue'
import NavMenuItem from './NavMenuItem.vue'
import Search from './NavSearch.vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import LottieWeb from 'lottie-web'
import headerLogoJson from '@/assets/lottie/header-logo.json'
import searchIcon from '@/assets/img/search.svg'
import { ref, watch, onMounted, onBeforeUnmount, nextTick, computed } from 'vue'
import { useStore } from '@/stores/main'
import useUtils from '@/components/composables/useUtils.js'
import useBannerShown from '@/components/composables/useBannerShown.js'
import useIntroShown from '@/components/composables/useIntroShown.js'
import useSmoothScroll from '@/components/composables/useSmoothScroll'
import { debounce } from 'debounce'
import { useRoute } from 'vue-router'

gsap.registerPlugin(ScrollTrigger)

const props = defineProps({
  name: String,
  hideNav: Boolean,
})

const { scrollY, device, genUUID, convertToRelative, isExternal } = useUtils()
const { introShown, preIntroShown } = useIntroShown()
const { locoScroll } = useSmoothScroll()
const { bannerShown, setBannerShown } = useBannerShown()
const route = useRoute()

const store = useStore()
const getMenu = (name) => store.menu({ name }) || []
const menu = ref(getMenu('main-menu'))
const mobileMenu = ref(getMenu('mobile-menu'))
const topMenu = ref(getMenu('top-menu'))
const site = ref(store.acfOptions())
const header = ref()
const nav = ref()
const navWrapper = ref()
const sticky = ref()
const navOpen = ref()
const displaySearch = ref()
const banner = ref(null)
const activeDesktopMegaItem = ref(null)

const headerLottieAnimID = ref(`logo-anim-${genUUID().substring(0, 5)}`)
const footerNavAnimID = ref(`footer-nav-anim-${genUUID().substring(0, 5)}`)
const lottieContainer = ref()
const lottieContainerMobile = ref()
const NO_BANNER_TOP = 25
const NAV_OPEN_NO_BANNER_TOP = 16
const BANNER_GAP_TOP = 16

let bannerResizeObserver = null
let bannerOffset = NO_BANNER_TOP
let headerPositionFrame = null
let lastHeaderTranslate = null
let lastStickyState = null

const normalizeBannerPath = (value) => {
  if (!value) return ''

  try {
    const path = new URL(value, window.location.origin).pathname
    return path === '/' ? path : path.replace(/\/+$/, '')
  } catch (error) {
    return ''
  }
}

const bannerHiddenOnCurrentPage = computed(() => {
  const hiddenPages =
    site.value?.banner?.hide_banner_on_page ||
    site.value?.banner?.hideBannerOnPage ||
    []
  const selectedPages = Array.isArray(hiddenPages) ? hiddenPages : [hiddenPages]
  const currentPath = normalizeBannerPath(route.path)

  return selectedPages.some(
    (hiddenPage) =>
      !!hiddenPage && normalizeBannerPath(hiddenPage) === currentPath
  )
})

const showBanner = computed(
  () =>
    !!site.value?.banner?.show_banner &&
    !bannerShown.value &&
    !props.hideNav &&
    !bannerHiddenOnCurrentPage.value
)

const animateOnScroll = () => {
  if (!lottieContainer.value) {
    setTimeout(() => {
      animateOnScroll()
    }, 100)
  } else {
    const anim = LottieWeb.loadAnimation({
      container: lottieContainer.value,
      renderer: 'svg',
      autoplay: false,
      loop: false,
      animationData: headerLogoJson,
    })

    const animMob = LottieWeb.loadAnimation({
      container: lottieContainerMobile.value,
      renderer: 'svg',
      autoplay: false,
      loop: false,
      animationData: headerLogoJson,
    })

    ScrollTrigger.create({
      trigger: 'body',
      start: 'top+=140 top',
      end: 'top+=1000 top',
      onUpdate: ({ progress }) => {
        animMob.goToAndStop(progress * (anim.totalFrames - 1), true)
      },
      markers: false,
      id: headerLottieAnimID.value,
    })

    ScrollTrigger.create({
      trigger: 'body',
      start: 'top+=140 top',
      end: 'top+=1000 top',
      onUpdate: ({ progress }) => {
        anim.goToAndStop(progress * (anim.totalFrames - 1), true)
      },
      markers: false,
      id: headerLottieAnimID.value,
    })
  }
}

const introTransition = () => {
  if (introShown.value) {
    gsap.fromTo(
      lottieContainer.value,
      { y: -200 },
      { y: 0, duration: 1, delay: 0.5 }
    )
    gsap.fromTo(
      lottieContainerMobile.value,
      { y: -200 },
      { y: 0, duration: 1, delay: 0.5 }
    )
  } else {
    setTimeout(() => {
      introTransition()
    }, 100)
  }
}

const onResize = () => {
  navOpen.value = false
  closeDesktopMegaMenu()
  pseudoMounted()
  syncBannerOffset()
  scheduleHeaderPosition()
  nextTick(syncDesktopNavWidth)
  // ScrollTrigger.refresh()
}

const resizeHandler = debounce(onResize, 500)

const getBannerOffset = () => {
  return bannerOffset
}

const hasActiveBanner = () => {
  return !!(showBanner.value && banner.value)
}

const getTranslatedTop = () => {
  if (!hasActiveBanner()) return NO_BANNER_TOP

  const offset = getBannerOffset()
  const translatedTop = offset - scrollY.value
  return Math.max(0, translatedTop)
}

const applyHeaderTranslate = (y) => {
  if (!header.value || lastHeaderTranslate === y) return

  lastHeaderTranslate = y
  header.value.style.setProperty(
    'transform',
    `translate3d(0, ${y}px, 0)`,
    'important'
  )
}

const setNavVisibility = (isVisible) => {
  if (!header.value) return

  header.value.style.pointerEvents = isVisible ? 'auto' : 'none'
  gsap.to(header.value, {
    autoAlpha: isVisible ? 1 : 0,
    duration: 0.3,
    ease: 'power2.out',
    overwrite: true,
  })
}

const setStickyState = (isSticky) => {
  if (!header.value || lastStickyState === isSticky) return

  lastStickyState = isSticky
  header.value.classList.toggle('sticky', isSticky)
  sticky.value = isSticky
}

const syncBannerOffset = () => {
  bannerOffset = banner.value
    ? banner.value.offsetHeight + BANNER_GAP_TOP
    : NO_BANNER_TOP
}

const observeBannerSize = () => {
  if (bannerResizeObserver) {
    bannerResizeObserver.disconnect()
    bannerResizeObserver = null
  }

  syncBannerOffset()

  if (!banner.value || typeof ResizeObserver === 'undefined') return

  bannerResizeObserver = new ResizeObserver(() => {
    syncBannerOffset()
    scheduleHeaderPosition()
  })
  bannerResizeObserver.observe(banner.value)
}

const initFooterHideTrigger = (attempt = 0) => {
  const footer = document.querySelector('.site-footer')

  if (!footer) {
    if (attempt < 30) {
      setTimeout(() => {
        initFooterHideTrigger(attempt + 1)
      }, 200)
    }
    return
  }

  if (ScrollTrigger.getById(footerNavAnimID.value)) return

  ScrollTrigger.create({
    trigger: footer,
    start: 'top+=300 bottom',
    end: 'bottom bottom-=100',
    id: footerNavAnimID.value,
    markers: false,
    onToggle: ({ isActive }) => {
      setNavVisibility(!isActive)
    },
  })
}

const resetFooterHideTrigger = () => {
  const footerAnim = ScrollTrigger.getById(footerNavAnimID.value)
  if (footerAnim) footerAnim.kill()

  setNavVisibility(true)

  nextTick(() => {
    setTimeout(() => {
      initFooterHideTrigger()
      ScrollTrigger.refresh()
    }, 120)
  })
}

const updateHeaderPosition = () => {
  if (!header.value) return

  // Nav is opened
  if (navOpen.value) {
    setStickyState(false)

    // Nav is opened and the banner still exists on the DOM
    if (hasActiveBanner()) {
      applyHeaderTranslate(0)
    }
    // Nav is opened but the banner does not exist on the DOM
    else {
      applyHeaderTranslate(NAV_OPEN_NO_BANNER_TOP)
    }
  }

  // Nav is closed
  else {
    if (hasActiveBanner()) {
      const translatedTop = getTranslatedTop()
      const stickyState = translatedTop <= 0
      setStickyState(stickyState)
      applyHeaderTranslate(translatedTop)
      return
    }

    setStickyState(false)
    applyHeaderTranslate(NO_BANNER_TOP)
  }
}

const scheduleHeaderPosition = () => {
  if (headerPositionFrame !== null) return

  headerPositionFrame = window.requestAnimationFrame(() => {
    headerPositionFrame = null
    updateHeaderPosition()
  })
}

watch(scrollY, scheduleHeaderPosition)

watch(navOpen, () => {
  scheduleHeaderPosition()
})

watch(bannerShown, () => {
  nextTick(() => {
    pseudoMounted()
    observeBannerSize()
    scheduleHeaderPosition()
    syncDesktopNavWidth()
  })
})

watch(preIntroShown, () => {
  nextTick(syncDesktopNavWidth)
})

watch(
  () => route.fullPath,
  () => {
    closeDesktopMegaMenu()
    resetFooterHideTrigger()

    nextTick(() => {
      pseudoMounted()
      observeBannerSize()
      scheduleHeaderPosition()
      syncDesktopNavWidth()
    })
  }
)

const childrenOf = (parentItem, sourceMenu = menu.value) => {
  if (!parentItem || !Array.isArray(sourceMenu)) {
    return []
  }

  return sourceMenu.filter((menuItem) => menuItem.parent == parentItem.id)
}

const openDesktopMegaMenu = (item) => {
  if (device.value !== 'desktop') {
    return
  }

  const childItems = childrenOf(item)

  if (!childItems.length) {
    closeDesktopMegaMenu()
    return
  }

  activeDesktopMegaItem.value = item
}

const closeDesktopMegaMenu = () => {
  activeDesktopMegaItem.value = null
}

const desktopSecondaryItems = computed(() =>
  childrenOf(activeDesktopMegaItem.value)
)

const desktopTertiaryGroups = computed(() =>
  desktopSecondaryItems.value
    .map((secondary) => ({
      secondary,
      items: childrenOf(secondary),
    }))
    .filter((group) => group.items.length)
)

const menuHasNestedItems = (sourceMenu) =>
  Array.isArray(sourceMenu) &&
  sourceMenu.some((menuItem) => menuItem.parent && menuItem.parent !== '0')

const syncDesktopNavWidth = () => {
  if (!nav.value || !navWrapper.value || device.value !== 'desktop') {
    return
  }

  const navWidth = nav.value.getBoundingClientRect().width

  if (navWidth > 0) {
    navWrapper.value.style.setProperty(
      '--desktop-nav-width',
      `${Math.ceil(navWidth)}px`
    )
  }
}

const mobileNavigationMenu = computed(() => {
  const baseMenu = menuHasNestedItems(mobileMenu.value)
    ? mobileMenu.value
    : menu.value

  return [...baseMenu, ...topLevelMenu(topMenu.value)]
})

const pseudoMounted = () => {
  if (showBanner.value && banner.value && header.value) {
    document.body.classList.add('has-top-banner')
  } else {
    document.body.classList.remove('has-top-banner')
  }
}

onMounted(() => {
  nextTick(() => {
    pseudoMounted()
    observeBannerSize()
    scheduleHeaderPosition()
    syncDesktopNavWidth()
  })
})

onMounted(() => {
  gsap.set(lottieContainer.value, { y: -200 })
  gsap.set(lottieContainerMobile.value, { y: -200 })
  gsap.set(header.value, { autoAlpha: 1 })
  introTransition()
  animateOnScroll()
  observeBannerSize()
  scheduleHeaderPosition()
  initFooterHideTrigger()
  window.addEventListener('resize', resizeHandler)

  nextTick(() => {
    syncDesktopNavWidth()
  })
})

onBeforeUnmount(() => {
  const lottieAnim = ScrollTrigger.getById(headerLottieAnimID.value)
  const footerAnim = ScrollTrigger.getById(footerNavAnimID.value)
  if (lottieAnim) lottieAnim.kill()
  if (footerAnim) footerAnim.kill()
  if (bannerResizeObserver) bannerResizeObserver.disconnect()
  if (headerPositionFrame !== null) {
    window.cancelAnimationFrame(headerPositionFrame)
  }
  window.removeEventListener('resize', resizeHandler)
})

const showSearch = () => {
  displaySearch.value = !displaySearch.value

  const html = document.querySelector('html')
  if (displaySearch.value) {
    html.classList.add('no-overflow')
  } else {
    html.classList.remove('no-overflow')
  }
}
const topLevelMenu = (menu) => {
  if (!Array.isArray(menu)) {
    return []
  }

  const topMenuItems = menu.filter((x) => x.parent === '0')
  return topMenuItems
}
const toggle = () => {
  navOpen.value = !navOpen.value
  closeDesktopMegaMenu()
  if (navOpen.value) {
    locoScroll.value.stop()
  } else {
    locoScroll.value.start()
  }
}
const close = (data) => {
  if (data !== undefined) navOpen.value = data
  else navOpen.value = !navOpen.value
  closeDesktopMegaMenu()
  locoScroll.value.start()
}
const beforeEnter = (el) => {
  // add the initial style to the elements
  el.style.transform = 'translateY(10px)'
  el.style.opacity = 0
}
const enter = (el) => {
  gsap.to(el, {
    y: 0,
    opacity: 1,
    duration: 0.3,
    delay: el.dataset.ind * 0.3,
  })
}
</script>

<style lang="scss" scoped>
.header-wrapper {
  .top-banner {
    @apply relative py-6 lg:py-4 w-full;
    background: linear-gradient(90deg, #1e6b5c 0%, #0e4343 100%);

    &.blue-variation {
      @apply min-h-[67px] flex justify-center items-center;
      background: linear-gradient(270deg, rgb(0 135 209), rgb(0 69 107));

      .exit {
        @apply border rounded-full border-white w-[31px] h-[31px] flex justify-center items-center;
        @apply right-5 lg:top-[calc(50%_-_15px)];
      }

      .banner-content {
        @apply lg:w-full;

        .inner-container:deep() {
          @apply max-w-[calc(100%_-_50px)] flex flex-col gap-2 items-start pr-[80px] sm:max-w-none md:w-full;
          @apply md:px-16 md:flex-row md:text-center md:items-center md:justify-center md:gap-0 lg:px-16;

          > img {
            @apply mr-1 max-w-[167px] max-h-[22px] object-scale-down;
          }

          .banner-text {
            * {
              @apply text-[16px] leading-[1.3] md:leading-none md:pt-[7px] lg:text-[20px];
            }
          }
        }
      }
    }

    .exit {
      @apply absolute top-5 z-20 right-3 cursor-pointer lg:right-4;
    }

    .banner-content {
      .inner-container:deep() {
        @apply flex flex-row pl-5 pr-10 max-w-[80%] lg:max-w-full ml-0 justify-start items-center gap-4 flex-wrap;
        @apply lg:gap-10 lg:justify-center;

        @apply text-white;

        .banner-text {
          * {
            @apply text-white text-[16px] leading-[20px] tracking-[-0.32px];
          }

          a {
            @apply text-white underline;
          }
        }
        .banner-button {
          display: flex;
          padding: 4px 13px;
          justify-content: center;
          align-items: center;
          gap: 5px;
          color: #000;
          border-radius: 29px;
          background-color: #13d377;
          font-size: 16px;

          @apply lg:py-2;
        }
      }
    }
  }
}

#header-nav.mobile {
  @apply fixed top-0 text-black px-[6px];

  // top: 35px !important;
}

#header-nav {
  @apply fixed w-full px-[20px] lg:overflow-visible;
  transition-property: color, background-color;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  will-change: transform;

  &.no-banner {
    top: 0 !important;
    position: fixed !important;
  }
  // padding-top: 35px !important;

  .logo-container img:not(.logo-white) {
    @apply h-[37px] lg:h-[45px];
  }

  &.has-banner {
    @apply flex-wrap gap-4 lg:gap-9;
  }
}
#header-nav.sticky {
  @apply top-0 mt-0 lg:fixed fixed;
  @apply lg:text-black;
  nav {
    @apply max-h-[70px] border-none;

    @media (min-width: 1024px) {
      max-height: none;
    }

    .logo-container {
      img {
        @apply w-[80%] h-full max-h-[50px] lg:mt-0;
      }
    }
  }
}
#header-nav.nav-open {
  .line-one {
    @apply transform w-7 rotate-45 translate-y-[10px] translate-x-[0px];

    &:before {
      @apply w-7 bg-white;
    }
  }
  .line-three {
    @apply transform -rotate-45 -translate-y-[10px] -translate-x-[0px];
    &:before {
      @apply w-7 bg-white;
    }
  }
  .line-two {
    @apply opacity-0;
  }
  .branding {
    @apply relative bg-[rgba(255,255,255,0.05)];
    box-shadow: 0px 2px 1px 0px #ffffff26 inset;
    // filter: brightness(100);
  }

  @media (max-width: 1023px) {
    nav::before {
      opacity: 0;
    }

    .branding {
      background: transparent;
      box-shadow: none;
    }
  }

  .nav-wrapper {
    @apply visible opacity-100;
  }
}

.header-nav {
  @apply flex mt-0 mb-0 items-stretch
         justify-center top-0 min-h-[50px] max-h-[50px]
         text-black
         lg:text-black z-[40];

  @media (min-width: 1024px) {
    max-height: none;
  }

  nav {
    @apply relative isolate w-full flex flex-col lg:grid lg:grid-cols-[auto_minmax(0,1fr)] lg:grid-rows-[auto_66px] items-stretch lg:h-auto
    lg:items-center pt-0 xl:px-3 2xl:px-0 lg:py-0
    transition-all duration-300 ease-in-out
    rounded-[15px];

    @media (min-width: 1024px) {
      max-height: none;
    }

    &::before {
      @apply pointer-events-none absolute inset-0 z-0 rounded-[15px] backdrop-blur-[20px] lg:top-auto lg:h-[66px];
      content: '';
      -webkit-backdrop-filter: blur(20px);
      backdrop-filter: blur(20px);
      background: linear-gradient(
          0deg,
          rgba(30, 107, 92, 0.06),
          rgba(30, 107, 92, 0.06)
        ),
        linear-gradient(
          270deg,
          rgba(255, 255, 255, 0.2) 44.96%,
          rgba(255, 255, 255, 0) 58.69%
        ),
        linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.2) 11.27%,
          rgba(255, 255, 255, 0) 23.4%
        ),
        rgba(255, 255, 255, 0.42);
      box-shadow: inset 0px 2px 1px rgba(255, 255, 255, 0.15);
    }

    ul {
      @apply flex flex-col my-3 lg:my-0 lg:flex-row lg:gap-14 justify-start items-center lg:items-end md:px-0 lg:px-5 xl:px-0;

      li {
        @apply flex w-full lg:w-auto text-left;
      }
    }
  }

  .desktop-top-menu {
    @apply pointer-events-auto relative z-2 m-0 mb-[5px] hidden w-full list-none items-center justify-end gap-7 px-8 pt-[10px] py-[6px] lg:flex;
    grid-column: 1 / -1;
    grid-row: 1;
    justify-self: stretch;

    &::before {
      @apply pointer-events-none absolute inset-0 z-0 rounded-[15px] backdrop-blur-[20px];
      content: '';
      -webkit-backdrop-filter: blur(20px);
      backdrop-filter: blur(20px);
      background: linear-gradient(
          0deg,
          rgba(30, 107, 92, 0.06),
          rgba(30, 107, 92, 0.06)
        ),
        linear-gradient(
          270deg,
          rgba(255, 255, 255, 0.2) 44.96%,
          rgba(255, 255, 255, 0) 58.69%
        ),
        linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.2) 11.27%,
          rgba(255, 255, 255, 0) 23.4%
        ),
        rgba(255, 255, 255, 0.42);
      box-shadow: inset 0px 2px 1px rgba(255, 255, 255, 0.15);
    }
  }

  .desktop-top-menu-item {
    @apply relative z-1 m-0 flex w-auto;
  }

  .desktop-top-menu-link {
    @apply relative z-1 text-[14px] leading-none text-humble no-underline transition-opacity duration-300 hover:opacity-70;
  }

  .branding {
    @apply relative z-1 h-[50px] w-full lg:w-[30%] xl:w-[35%] text-center rounded-[15px]
           md:text-left flex items-center lg:max-h-[65px]
           justify-between p-3 xl:p-0 lg:shadow-none;
    @apply lg:col-start-1 lg:row-start-2;

    .logo-container {
      @apply h-full xl:pl-4 xl:max-h-full flex items-center;
      position: relative;
      top: -10;
      img:not(.logo-white) {
        @apply w-[80%] lg:w-auto h-[30px] lg:h-[45px] lg:pl-0;
      }

      &-mobile {
        @apply relative;

        .lottie-container {
          @apply transition-all;
        }

        .logo-white {
          @apply opacity-0 absolute top-0 left-0 w-full h-full transition-all;
        }
        .logo-not-visible {
          @apply opacity-0;
        }

        .logo-visible {
          @apply opacity-100;
        }
      }
      .lottie-container {
        height: 45px;
        width: 150px;
      }
    }
    .mobile-nav {
      @apply flex flex-col lg:hidden float-right;
      .line {
        @apply mb-2 transition-all duration-500 ease-in-out;
      }
      .line:last-child {
        @apply mb-0;
      }
      .line:before {
        @apply content-[''] block h-[2px] w-[20px] bg-humble
        transition-all duration-500 ease-in-out;
      }
      .line:nth-child(2):before {
        @apply w-[25px];
      }
    }
  }
  .nav-container {
    @apply relative z-1 w-full lg:w-fit
             text-center md:text-left
             transition duration-500 ease-in-out m-0 place-items-start justify-end
             lg:pr-[50px];
    @apply lg:col-start-2 lg:row-start-2;
    justify-self: end;
    height: fit-content;
  }
  .nav-wrapper {
    @apply transition-all duration-500 ease-in-out bg-humble
    invisible opacity-0 absolute top-0 left-[-6px] -z-1
    w-[103vw] m-0 overflow-hidden;
    height: 100vh;
    height: 100dvh;

    .nav-mobile {
      @apply transition-all duration-500 ease-in-out
      relative px-[30px] pt-[85px] w-full h-full overflow-y-auto
      flex flex-col justify-start items-start;
      max-height: none;
      padding-bottom: calc(40px + env(safe-area-inset-bottom));
      overscroll-behavior-y: contain;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-y;
    }
  }

  .desktop-mega-menu {
    @apply hidden lg:block absolute left-0 right-0 top-full z-50 w-full overflow-visible bg-transparent text-balanced;
    @apply lg:bg-transparent lg:top-full;
    pointer-events: none;

    &::before,
    &::after {
      @apply pointer-events-none absolute inset-0 z-0 rounded-[15px] top-[5px];
      content: '';
      left: auto;
      width: var(--desktop-nav-width, 658px);
    }

    &::before {
      -webkit-backdrop-filter: blur(0px);
      backdrop-filter: blur(0px);
      background: transparent;
      box-shadow: none;
      transition: -webkit-backdrop-filter 0.15s ease-in-out,
        backdrop-filter 0.15s ease-in-out, background 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }

    &::after {
      -webkit-backdrop-filter: blur(0px);
      backdrop-filter: blur(0px);
      background: rgba(255, 255, 255, 0.001);
      opacity: 0;
      -webkit-mask-image: linear-gradient(90deg, transparent 1.64%, #000 50%);
      mask-image: linear-gradient(90deg, transparent 1.64%, #000 50%);
      transition: opacity 0.15s ease-in-out,
        -webkit-backdrop-filter 0.15s ease-in-out,
        backdrop-filter 0.15s ease-in-out;
    }
  }

  nav:hover .desktop-mega-menu.is-open .desktop-mega-surface,
  .desktop-mega-menu.is-open .desktop-mega-surface:hover {
    pointer-events: auto;
  }

  nav:hover .desktop-mega-menu.is-open::before,
  .desktop-mega-menu.is-open:hover::before {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.85);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.15),
      -2px 2px 16px rgba(0, 0, 0, 0.03);
  }

  nav:hover .desktop-mega-menu.is-open::after,
  .desktop-mega-menu.is-open:hover::after {
    -webkit-backdrop-filter: blur(40px);
    backdrop-filter: blur(40px);
    opacity: 1;
  }

  .desktop-mega-surface {
    @apply relative z-1 isolate ml-auto overflow-hidden rounded-[15px];
    width: var(--desktop-nav-width, 658px);
    pointer-events: none;
  }

  .desktop-mega-content-layer {
    @apply relative w-full;
    will-change: opacity, transform;
  }

  .desktop-mega-content-enter-active {
    z-index: 2;
    transition: opacity 0.2s ease-out;
  }

  .desktop-mega-content-leave-active {
    @apply pointer-events-none absolute inset-0;
    z-index: 1;
    transition: opacity 0.16s ease-in,
      transform 0.22s cubic-bezier(0.4, 0, 1, 1);
  }

  .desktop-mega-content-enter-from,
  .desktop-mega-content-leave-to {
    @apply opacity-0;
  }

  .desktop-mega-content-enter-to,
  .desktop-mega-content-leave-from {
    @apply opacity-100;
  }

  .desktop-mega-content-leave-to {
    transform: translate3d(0, -10px, 0);
  }

  .desktop-mega-content-enter-active .desktop-mega-secondary-title,
  .desktop-mega-content-enter-active .desktop-mega-tertiary-item {
    transition: opacity 0.2s ease-out,
      transform 0.24s cubic-bezier(0.22, 1, 0.36, 1);
  }

  .desktop-mega-content-enter-active .desktop-mega-secondary-title {
    transition-delay: 0.02s;
  }

  .desktop-mega-content-enter-active .desktop-mega-tertiary-item {
    transition-delay: calc(0.02s + var(--mega-item-index, 0) * 0.025s);
  }

  .desktop-mega-content-enter-from .desktop-mega-secondary-title,
  .desktop-mega-content-enter-from .desktop-mega-tertiary-item {
    @apply opacity-0;
    transform: translate3d(0, 14px, 0);
  }

  .desktop-mega-content-enter-to .desktop-mega-secondary-title,
  .desktop-mega-content-enter-to .desktop-mega-tertiary-item {
    @apply opacity-100;
    transform: translate3d(0, 0, 0);
  }

  .desktop-mega-tertiary {
    @apply relative z-1 overflow-hidden bg-transparent;
    min-width: 0;
  }

  .desktop-mega-secondary-title {
    @apply m-0 p-5 text-[60px] font-light leading-[1.1] tracking-[-1.2px] text-balanced;

    :deep(span) {
      @apply text-humble;
    }
  }

  .desktop-mega-tertiary {
    @apply m-0 flex w-full flex-col self-stretch gap-[22px] rounded-[15px] p-[30px];
  }

  .desktop-mega-tertiary-content {
    min-width: 0;
    @apply flex flex-col justify-start;
  }

  .desktop-mega-tertiary-list {
    @apply m-0 flex list-none flex-col items-stretch gap-0 p-0;
  }

  .desktop-mega-tertiary-item {
    @apply m-0 block w-full;
  }

  .desktop-mega-tertiary-link {
    @apply flex w-full rounded-[10px] bg-[#1E6B5C]/0 flex-col items-start gap-1 no-underline transition-all duration-300;
    @apply lg:pt-5 lg:pl-5 lg:pb-5 lg:pr-14;

    svg {
      @apply absolute right-4 bottom-4 opacity-0 transition-opacity duration-300;
    }

    &:hover {
      @apply bg-[#1E6B5C]/10;

      svg {
        @apply opacity-100;
      }
    }
  }

  .desktop-mega-tertiary-title {
    @apply text-[16px] font-medium font-FKGrotesk leading-[1.1] text-balanced;
  }

  .desktop-mega-tertiary-description {
    @apply text-[15px] font-normal leading-[1.25] text-balanced;
  }

  @media (prefers-reduced-motion: reduce) {
    .desktop-mega-content-enter-active,
    .desktop-mega-content-leave-active,
    .desktop-mega-content-enter-active .desktop-mega-secondary-title,
    .desktop-mega-content-enter-active .desktop-mega-tertiary-item {
      transition-duration: 0.01ms;
      transition-delay: 0s;
    }
  }
}
#searchIcon {
  @apply mt-[5px] pl-5 cursor-pointer mx-auto py-4 lg:py-0;
}
</style>
